import { render, staticRenderFns } from "./dialog_product_detail.vue?vue&type=template&id=efda22dc&scoped=true&"
import script from "./dialog_product_detail.vue?vue&type=script&lang=js&"
export * from "./dialog_product_detail.vue?vue&type=script&lang=js&"
import style0 from "./dialog_product_detail.vue?vue&type=style&index=0&id=efda22dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efda22dc",
  null
  
)

export default component.exports